export * from "./view-segments/view-segments.component"